(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import * as T from "./types";
export const push = location => ({
  type: T.LOCATION_PUSH,
  payload: location
});
export const replace = location => ({
  type: T.LOCATION_REPLACE,
  payload: location
});
export const pop = () => ({
  type: T.LOCATION_POP
});
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(push, "push", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/BrowserHistory/state/actions.js");
  reactHotLoader.register(replace, "replace", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/BrowserHistory/state/actions.js");
  reactHotLoader.register(pop, "pop", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/BrowserHistory/state/actions.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();